import type { ReferenceWorkSpace } from '../model/types';
import { CatalogDetailDialog } from './ReferenceLifecycle';

type WorkSpaceDetailDialogProps = {
  workSpace?: ReferenceWorkSpace;
  canWrite: boolean;
  onClose: () => void;
  onEdit: () => void;
  onLifecycle: (action: 'end' | 'reactivate') => void;
};

export function WorkSpaceDetailDialog({
  workSpace,
  canWrite,
  onClose,
  onEdit,
  onLifecycle,
}: WorkSpaceDetailDialogProps) {
  return (
    <CatalogDetailDialog
      item={workSpace}
      kindLabel="업무 공간"
      canWrite={canWrite}
      canEdit={workSpace?.status !== 'SCHEDULED'}
      editDisabledReason={
        workSpace?.status === 'SCHEDULED' ? '사용 예정인 업무 공간은 적용일 이후 수정할 수 있습니다.' : undefined
      }
      extraItems={workSpace ? [['근무지', workSpace.location.descriptor]] : []}
      onClose={onClose}
      onEdit={onEdit}
      onLifecycle={onLifecycle}
    />
  );
}
